var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 291,
    viewBox: "0 0 444 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1106_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.206 152.504C379.826 149.386 380.157 146.161 380.157 142.854C380.157 115.746 358.194 93.773 331.099 93.773C327.625 93.773 324.239 94.1425 320.972 94.8313C321.065 93.1468 321.122 91.4498 321.122 89.7466C321.128 40.1831 280.964 0 231.417 0C192.185 0 158.862 25.2044 146.675 60.3028C137.124 54.6419 125.983 51.3857 114.078 51.3857C78.6953 51.3857 50.0163 80.0781 50.0163 115.477C50.0163 125.026 52.1193 134.075 55.8622 142.216C23.6843 150.951 0 180.345 0 215.274C0 257.066 33.8992 291 75.691 291H418.413C434.167 276.215 444 255.213 444 231.9C444 192.7 416.172 160.006 379.206 152.504Z",
    fill: "url(#paint0_linear_1106_439)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_439",
    x1: 222,
    y1: 0,
    x2: 222,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391559",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 444,
    height: 291,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCloud1);
export default __webpack_public_path__ + "static/media/hero-cloud-1.4abde70d8a86f561f3f867b64c5dd3fd.svg";
export { ForwardRef as ReactComponent };